export interface AppButtonSize {
  width: number;
  height: number;
  borderRadius: string;
}

export interface ProfileImageSize {
  width: number;
  height: number;
}

export interface ButtonSize {
  innerCircleEnabledSize: {width: number; height: number; borderRadius: string};
  iconEnabledSize: {width: number; height: number};
  iconContainerEnabledSize: {width: number; height: number};
}

export interface GenericCollapsibleSidePanelSizes {
  width: {open: number; closed: number};
}

export interface SideHamburguerMenu {
  width: {
    open: number;
    closed: number;
  };
}

export interface dailyCarelogSizes {
  headerHeight: number;
  footerHeight: number;
}

export interface AppSizes {
  appButtonSize: AppButtonSize;
  profileImageSize: ProfileImageSize;
  systemButtonSize: ButtonSize;
  xsButtonSize: ButtonSize;
  genericCollapsibleSidePanel: GenericCollapsibleSidePanelSizes;
  sideHamburguerMenu: SideHamburguerMenu;
  dailyCareLog: dailyCarelogSizes;
}

export const appSizes: AppSizes = {
  sideHamburguerMenu: {
    width: {
      open: 182,
      closed: 72,
    },
  },
  genericCollapsibleSidePanel: {
    width: {
      open: 200,
      closed: 64,
    },
  },
  // https://www.figma.com/file/YsnJlc46hCDyIePJFPslLN/01---Pattern-Library?node-id=7978%3A28842
  appButtonSize: {
    width: 292,
    height: 288,
    borderRadius: '20px',
  },
  // https://www.figma.com/file/YsnJlc46hCDyIePJFPslLN/01---Pattern-Library?node-id=6575%3A91898
  profileImageSize: {
    width: 300,
    height: 300,
  },
  // https://www.figma.com/file/YsnJlc46hCDyIePJFPslLN/01---Pattern-Library?node-id=6495%3A19948
  systemButtonSize: {
    innerCircleEnabledSize: {width: 224, height: 224, borderRadius: '50%'},
    iconEnabledSize: {
      width: 76,
      height: 76,
    },
    iconContainerEnabledSize: {
      width: 112,
      height: 112,
    },
  },
  // https://www.figma.com/file/YsnJlc46hCDyIePJFPslLN/01---Pattern-Library?node-id=6570%3A28520
  xsButtonSize: {
    innerCircleEnabledSize: {width: 104, height: 104, borderRadius: '50%'},
    iconEnabledSize: {
      width: 36,
      height: 36,
    },
    iconContainerEnabledSize: {
      width: 48,
      height: 48,
    },
  },
  dailyCareLog: {
    headerHeight: 60,
    footerHeight: 86,
  },
};
